export const POSITIVE_LIST_ANALYSIS_QUERY_KEY = "gdpr-software-positive-list-analysis";

export const ANALYSIS_POLL_INTERVAL_MS = 4000;

const IN_PROGRESS_STATUSES = new Set(["queued", "processing"]);

const OUTCOME_MESSAGE_KEYS = {
    no_measures: "The analysis finished and did not find any measures.",
    insufficient_sources: "There is not enough documentation to identify measures.",
    failed: "The analysis failed.",
};

export const isAnalysisInProgress = (status) => {
    return IN_PROGRESS_STATUSES.has(status);
};

/**
 * Banner for an in-progress, failed, or empty analysis.
 * A completed run that found measures does not need a banner.
 *
 * @param {{ status?: string, error?: string|null, result_outcome?: string|null }|null|undefined} analysis
 * @returns {{ color: string, messageKey: string }|null}
 */
export const getAnalysisNotice = (analysis) => {
    if (!analysis) {
        return null;
    }

    if (isAnalysisInProgress(analysis.status)) {
        return {
            color: "info",
            messageKey: "Positive List analysis is in progress.",
        };
    }

    if (analysis.status === "failed") {
        return {
            color: "danger",
            messageKey: analysis.error || "The analysis failed.",
        };
    }

    const outcomeMessage = OUTCOME_MESSAGE_KEYS[analysis.result_outcome];

    if (analysis.status === "completed" && outcomeMessage) {
        return {
            color: analysis.result_outcome === "failed" ? "danger" : "warning",
            messageKey: analysis.error || outcomeMessage,
        };
    }

    return null;
};
